import { ChannelAvatarGetList, ChannelAvatarGetListResponse } from "../proto/ChannelAvatarGetList_pb";
import { GroupAvatarGetList, GroupAvatarGetListResponse } from "../proto/GroupAvatarGetList_pb";
import { UserAvatarGetList, UserAvatarGetListResponse } from "../proto/UserAvatarGetList_pb";
import store from "../store";
import { addAvatars } from "../store/avatars/actions";
import BaseHandler from "./BaseHandler";

export default class HandleRoomAvatarGetListResponse extends BaseHandler<
  GroupAvatarGetListResponse | ChannelAvatarGetListResponse | UserAvatarGetListResponse,
  GroupAvatarGetList | ChannelAvatarGetList | UserAvatarGetList
> {
  handle() {
    const roomAvatarGetListRequest = this.request?.toObject();
    const roomAvatarGetListResponse = this.response.toObject();
    if (roomAvatarGetListRequest !== undefined) {
      store.dispatch(
        addAvatars({
          roomId: "userId" in roomAvatarGetListRequest ? roomAvatarGetListRequest.userId : roomAvatarGetListRequest?.roomId,
          avatars: roomAvatarGetListResponse.avatarList,
        })
      );
    }
  }
}
